import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { useStyle } from "./style";
import loaderGif from "@static/icons/Loader.gif";

export const BroadbandPendingContent = () => {
    const { t } = useTranslation("cart");
    const { classes } = useStyle();

    return (
        <Grid alignItems="center" container spacing={2}>
            <Grid item xs="auto">
                <img alt="" className={classes.loadingIcon} data-testid="loader-icon" src={loaderGif} />
            </Grid>
            <Grid item xs>
                <Typography className={classes.loadingText} variant="small">
                    {t("broadband.loadingMessage")}
                </Typography>
            </Grid>
        </Grid>
    );
};
